import React, { forwardRef } from 'react';
import { Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { Input } from '../Input';
import type { DatePickerProps } from './DatePicker.types';

/**
 * # DatePicker
 *
 * Wrapper kolem Inputu pro vyber data.
 * Zatim pouziva nativni <input type="date">, ale s jednotnym stylingem.
 *
 * @example
 * <DatePicker label="Datum narozeni" value={date} onChange={setDate} />
 */
export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ value, onChange, className, ...props }, ref) => {
    // Convert Date object to YYYY-MM-DD string for native input
    const formattedValue = value instanceof Date ? format(value, 'yyyy-MM-dd') : value || '';

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    };

    return (
      <Input
        ref={ref}
        type="date"
        value={formattedValue}
        onChange={handleChange}
        leftIcon={<Calendar size={18} />}
        className={className}
        {...props}
      />
    );
  },
);

DatePicker.displayName = 'DatePicker';
